export default __webpack_public_path__ + "static/media/toast-delete.d6578d7d.svg";